import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { IInvoiceCycle } from '../IInvoiceCycle';
import * as InvoiceCycleActions from './invoice-cycle.actions';

export const invoiceCyclesFeatureKey = 'invoiceCycles';

export interface State extends EntityState<IInvoiceCycle> {
    // additional entities state properties
}

export const adapter: EntityAdapter<IInvoiceCycle> =
    createEntityAdapter<IInvoiceCycle>();

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const invoiceCycleReducer = createReducer(
    initialState,
    on(InvoiceCycleActions.addInvoiceCycle, (state, action) =>
        adapter.addOne(action.invoiceCycle, state)
    ),
    on(InvoiceCycleActions.upsertInvoiceCycle, (state, action) =>
        adapter.upsertOne(action.invoiceCycle, state)
    ),
    on(InvoiceCycleActions.addInvoiceCycles, (state, action) =>
        adapter.addMany(action.invoiceCycles, state)
    ),
    on(InvoiceCycleActions.upsertInvoiceCycles, (state, action) =>
        adapter.upsertMany(action.invoiceCycles, state)
    ),
    on(InvoiceCycleActions.updateInvoiceCycle, (state, action) =>
        adapter.updateOne(action.invoiceCycle, state)
    ),
    on(InvoiceCycleActions.updateInvoiceCycles, (state, action) =>
        adapter.updateMany(action.invoiceCycles, state)
    ),
    on(InvoiceCycleActions.deleteInvoiceCycle, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(InvoiceCycleActions.deleteInvoiceCycles, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(InvoiceCycleActions.loadInvoiceCycles, (state, action) =>
        adapter.setAll(action.invoiceCycles, state)
    ),
    on(InvoiceCycleActions.clearInvoiceCycles, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return invoiceCycleReducer(state, action);
}

export const selectInvoiceCycleState = createFeatureSelector<State>(
    invoiceCyclesFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectInvoiceCycleState);
